import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "trigger", "paginationInfo" ]
  static values = { url: String }

  connect() {
    // console.log("Infinite scroll connected");
    // Optional: Implement Intersection Observer for automatic loading if this.hasTriggerTarget
  }

  disconnect() {
    // Optional: Disconnect Intersection Observer
  }

  async loadMore() {
    if (!this.hasPaginationInfoTarget || !this.hasUrlValue) {
      // console.log("No pagination info or URL value, cannot load more.");
      if(this.hasTriggerTarget) this.triggerTarget.remove(); // Clean up if no info to proceed
      return;
    }

    const nextPage = this.paginationInfoTarget.dataset.page;
    if (!nextPage) {
      // console.log("No next page data found.");
      if (this.hasTriggerTarget) this.triggerTarget.remove(); // No more pages, remove trigger
      return;
    }

    const url = new URL(this.urlValue);
    url.searchParams.set("page", nextPage);

    // Keep a reference to the current trigger and paginationInfo before they are removed
    const currentTrigger = this.triggerTarget;
    const currentPaginationInfo = this.paginationInfoTarget;

    if (currentTrigger && currentTrigger.querySelector('button')) {
      currentTrigger.querySelector('button').disabled = true;
      currentTrigger.querySelector('button').textContent = 'Loading...';
    }

    try {
      const response = await fetch(url.toString(), {
        headers: {
          "Accept": "text/html", // Request HTML
          "X-Requested-With": "XMLHttpRequest" // Often helpful for server to identify AJAX
        }
      });

      if (response.ok) {
        const htmlFragment = await response.text();
        
        // Remove the old trigger and pagination info elements that were part of the previous load
        if (currentTrigger) currentTrigger.remove();
        if (currentPaginationInfo) currentPaginationInfo.remove();
        
        // Append the new content (which includes new activities AND the next trigger/paginationInfo)
        this.containerTarget.insertAdjacentHTML('beforeend', htmlFragment);
      } else {
        console.error("Error loading more activities:", response.status, response.statusText);
        // Re-enable the button on error if it wasn't removed
        if (currentTrigger && currentTrigger.querySelector('button')) {
          currentTrigger.querySelector('button').disabled = false;
          currentTrigger.querySelector('button').textContent = 'Load More';
        }
      }
    } catch (error) {
      console.error("Error loading more activities:", error);
      if (currentTrigger && currentTrigger.querySelector('button')) {
        currentTrigger.querySelector('button').disabled = false;
        currentTrigger.querySelector('button').textContent = 'Load More';
      }
    }
  }
} 